module.exports = __webpack_public_path__ + "img/icon_kehu_12.02964f08.png";